import { Observable } from 'rxjs';
import { ServerService } from './server.service';


export class ServiceDefault {


  constructor(protected api: string, protected _server: ServerService) {
  }

  save(obj): Observable<any> {
    return this._server.post(this.api + '/save', obj);
  }

  view(id): Observable<any> {
    return this._server.get(this.api + '/view/' + id);
  }

  remove(id): Observable<any> {
    return this._server.get(this.api + '/remove/' + id);
  }

  list(params): Observable<any> {
    return this._server.post(this.api + '/list', params);
  }


  post(route, obj) {
    return this._server.post(this.api + '/' + route, obj);
  }

  get(route, params = {}) {
    return this._server.get(this.api + '/' + route, params);
  }
}
